import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeAgo',
  standalone: true,
})
export class TimeAgoPipe implements PipeTransform {
  transform(value: Date): string {
    if (!value) {
      return '';
    }

    const now = new Date();
    const timeDiffSeconds = Math.round((now.getTime() - value.getTime()) / 1000);
    if (timeDiffSeconds < 60) {
      return 'jetzt';
    }

    const timeDiffMinutes = Math.floor(timeDiffSeconds / 60);
    if (timeDiffMinutes < 60) {
      return `vor ${timeDiffMinutes} min`;
    }

    const timeDiffHours = Math.floor(timeDiffMinutes / 60);
    if (timeDiffHours < 24) {
      return `vor ${timeDiffHours} Std.`;
    }

    const timeDiffDays = Math.floor(timeDiffHours / 24);
    if (timeDiffDays < 30) {
      return `vor ${timeDiffDays} Tag${timeDiffDays > 1 ? 'en' : ''}`;
    }

    const timeDiffMonths = Math.floor(timeDiffDays / 30);
    if (timeDiffMonths < 12) {
      return `vor ${timeDiffMonths} Monat${timeDiffMonths > 1 ? 'en' : ''}`;
    }

    const timeDiffYears = Math.floor(timeDiffMonths / 12);
    return `vor ${timeDiffYears} Jahr${timeDiffYears > 1 ? 'en' : ''}`;
  }
}
